import { Component, ElementRef, OnInit, ViewChild, Input } from '@angular/core';
import { IconDictionaryService } from 'src/app/services/icon-dictionary.service';
import { FieldComponent } from 'tuain-ng-forms-lib';

@Component({
  selector: 'app-input',
  templateUrl: './app-input.component.html',
})
export class AppInputComponent extends FieldComponent implements OnInit {
  @Input() prefixIcon = '';
  @Input() suffixIconName = '';
  @ViewChild('inputElement', { static: true }) inputElement: ElementRef;

  constructor(public _iconDictionary: IconDictionaryService) {
    super();
  }

  override start() {
    super.start();
    const iconName = this.field?.getCustomAttribute('suffixIconName') ?? '';
    if (iconName) {
      this.suffixIconName = this._iconDictionary.mapIcon(iconName);
    }
  }

  override focus() {
    if (this.inputElement) {
      this.inputElement.nativeElement.focus();
    }
  }

  inputTypedCheck() {
    let formatOk = (this.value?.length > 0 && this.field.format)
      ? this.field.format.test(this.value) : true;
    if (this.value && this.type === 'ONLYTEXT') {
      formatOk = /^[A-Z]+$/i.test(this.value);
    }
    if (formatOk) {
      this.inputTyped();
    } else {
      this.value = this.field.value;
    }
  }
}
